module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12tn6m0/tc-custom/9781614170853.jpg?1685327059593",
      "alt": "This image is the cover for the book Orchids in Moonlight"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Orchids in Moonlight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Young Woman Searching for Her Father, Loses Her Heart to Her Outcast Guide in "), _c('i', [_vm._v("Orchids in Moonlight")]), _vm._v(" a Historical Western Romance by Patricia Hagan")]), _c('br'), _c('br'), _vm._v("Together, the lovers ride the dangerous Sierra Nevada ranges."), _c('br'), _c('br'), _vm._v("Jaime Chandler, searching for her father, is finally in the care of the one man—Cord Austin—who can safely lead her to San Francisco."), _c('br'), _c('br'), _vm._v("Cord Austin guards a dark secret and intends to leave his passion for Jaime behind in the dust."), _c('br'), _c('br'), _vm._v("But when Jaime's search for her father ends in an unexpected web of treachery and deceit, the lovers discover a truth neither dare deny."), _c('br'), _c('br'), _c('b', [_vm._v("THE SOULS AFLAME SERIES by Patricia Hagan")]), _c('br'), _c('i', [_vm._v("This Rebel Heart"), _c('br'), _vm._v("This Savage Heart")]), _c('br'), _c('br'), _c('b', [_vm._v("OTHER TITLES by Patricia Hagan")]), _c('br'), _c('i', [_vm._v("Say You Love Me"), _c('br'), _vm._v("Starlight"), _c('br'), _vm._v("Simply Heaven"), _c('br'), _vm._v("Orchids in Moonlight"), _c('br'), _vm._v("Final Justice"), _c('br'), _vm._v("Forbidden to Love"), _c('br'), _vm._v("Passion's Fury")]), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Patricia Hagan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Patricia Hagan is a New York Times bestselling author of 42 novels, proud mother of a U.S. Navy SEAL and is a native of Alabama.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ePublishing Works!\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0